/**
 * Created by Viacheslav Stepanian on 30.04.2026
 */

/* eslint-disable-next-line prefer-const */
let KingsCupStartWindow = Prefab.createWindow("kingscup_start_window", "kingscup_start_window_prefab_json", {
    theme: () => bundles.kingscup_start_window.jsons.theme_json
});
